import a from "./ghl-ui.es429.js";
var r = Object.create, u = function() {
  function e() {
  }
  return function(t) {
    if (!a(t))
      return {};
    if (r)
      return r(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
const o = u;
export {
  o as default
};
